import { Alert, Box, Button, Grid } from '@mui/material';
import React, { useCallback, useState } from 'react';
import Dropzone from 'react-dropzone';
import '../../../styles/fileupload.css';
import CustomButton from '../../elements/CustomButton';
import Modal from '../../elements/Modal';

function UploadPicture({
  handleClose,
  open,
  onSubmit,
  error,
  width,
  productPictures: initialProductPictures,
  loading,
}) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [productPictures, setProductPictures] = useState(
    initialProductPictures || []
  );

  const onDrop = useCallback(
    (files) => {
      setSelectedFiles([...selectedFiles, ...files]);
    },
    [selectedFiles]
  );

  const clearSelectedFiles = () => {
    if (selectedFiles.length > 0) {
      setSelectedFiles([]);
    }
  };

  const handleUpload = () => {
    setProductPictures([
      ...productPictures,
      ...selectedFiles.map((file) => URL.createObjectURL(file)),
    ]);
    onSubmit(selectedFiles);
    setSelectedFiles([]);
  };

  const handleModalClose = () => {
    handleClose();
    clearSelectedFiles();
  };

  return (
    <Modal
      open={open}
      modalTitle="Upload product pictures"
      handleClose={handleModalClose}
      width={width || 'sm'}>
      <Grid className="my-3" style={{ flex: 1 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          {error && (
            <Box m={1} width="100%">
              <Alert severity="error">{error}</Alert>
            </Box>
          )}

          <Dropzone onDrop={onDrop} multiple accept=".png, .jpg, .jpeg">
            {({ getRootProps, getInputProps }) => (
              <section
                style={{
                  width: '100%',
                  minHeight: '200px',
                  padding: '16px',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <div {...getRootProps({ className: 'dropzone' })}>
                  <input {...getInputProps()} />
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    border="2px dashed lightgray"
                    borderRadius="4px"
                    bgcolor="white"
                    color="text.secondary"
                    minHeight={100}
                    textAlign="center"
                    p={2}>
                    {selectedFiles.length > 0 ? (
                      selectedFiles.map((file, index) => (
                        <Grid
                          key={file.name}
                          container
                          spacing={2}
                          alignItems="center">
                          <Grid item xs={4}>
                            <img
                              alt="Selected File"
                              src={URL.createObjectURL(file)}
                              style={{ width: 50, height: 50 }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <h6>{file.name}</h6>
                          </Grid>
                        </Grid>
                      ))
                    ) : (
                      <p>Drag and drop files here, or click to select files</p>
                    )}
                  </Box>
                </div>
              </section>
            )}
          </Dropzone>
          <Grid
            gap="10px"
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="center">
            <CustomButton
              disabled={loading || selectedFiles.length === 0}
              sx={{ margin: 0 }}
              buttonLabel={loading ? 'Uploading...' : 'Upload'}
              onClick={handleUpload}
            />
            <Button
              sx={{ width: '180px' }}
              variant="outlined"
              color="error"
              disabled={loading || selectedFiles.length === 0}
              onClick={clearSelectedFiles}>
              Clear
            </Button>
          </Grid>
        </Box>
      </Grid>
    </Modal>
  );
}

export default UploadPicture;
